import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { InsightsService } from './insights.service';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

import { HttpClient } from '@angular/common/http';
import { investorPortalSettings, PORTAL_SETTINGS } from '../../settings';
import { SettingsModule } from '../../settings/settings.module';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

function loadAppSettings(httpClient: HttpClient, settings: investorPortalSettings) {
  return () => httpClient.get('/api2/corproSettings/instrumentationKey')
    .pipe(
      tap(resp => {
        Object.assign(settings, resp);
      }),
      catchError(err => {
        console.error(err);
        return EMPTY;
      }))
    .toPromise();
}

@NgModule({
  imports: [
    SettingsModule
  ],
  providers: [
    InsightsService,
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadAppSettings,
      deps: [HttpClient, PORTAL_SETTINGS],
      multi: true
    }
  ]
})
export class InsightsModule {
}
